import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { Constants } from '../constants/manage-activity-logs.constants';
import {
  MarginMaxMessage,
  ActivityInterface,
  ShowActivityInterface,
  MarginMaxActivityInterface,
} from '../interfaces/manage-activity-logs.interface';
import { ManageActivityLogsService } from '../services/manage-activity-logs/manage-activity-logs.service';

@Component({
  selector: 'ps-ui-manage-activity-logs',
  templateUrl: './manage-activity-logs.component.html',
  styleUrls: ['./manage-activity-logs.component.css'],
})
export class ManageActivityLogsComponent implements OnInit, OnDestroy {
  @Input() surveyId!: number | undefined;
  @Input() isMarginMaxTab: boolean = false;
  private _subscriptions: Subscription = new Subscription();
  public showActivities: ShowActivityInterface[] = [];
  public noActivityLog: boolean = false;
  constructor(
    private _manageActivityLogs: ManageActivityLogsService,
    private _auth: AuthService
  ) {}

  ngOnInit(): void {
    if (this.isMarginMaxTab) {
      this._getActivityLogsForMarginMax();
    } else {
      this._getActivityLogs();
    }
  }

  private _getActivityLogs() {
    const getActivityLogsData$ = this._manageActivityLogs
      .getActivityLogsData(this.surveyId)
      .subscribe((activities: ActivityInterface[]) => {
        activities.forEach((activity: ActivityInterface) => {
          if (
            this._auth.user?.operatorAcssLvls !== 'none' ||
            activity.buyerAdmin ||
            activity.buyerFull
          ) {
            this.showActivities.push({
              activityString: `${activity.username} ${activity.message}`,
              timeString: this._generateTimeString(activity.timestamp),
            });
          }
        });

        if (this.showActivities.length === 0) {
          this.noActivityLog = true;
        }
      });
    this._subscriptions.add(getActivityLogsData$);
  }

  private _getActivityLogsForMarginMax() {
    if (this.surveyId) {
      this.noActivityLog = true;
      const getActivityLogsDataForMarginMax = this._manageActivityLogs
        .getActivityLogsForMarginMax(this.surveyId)
        .subscribe((activities: MarginMaxActivityInterface) => {
          this.showActivities = activities.history.map(
            (activity: MarginMaxMessage) => {
              return {
                activityString: activity.message,
                timeString: this._generateTimeString(activity.timestamp),
              };
            }
          );
          if (this.showActivities.length) {
            this.noActivityLog = false;
          }
        });
      this._subscriptions.add(getActivityLogsDataForMarginMax);
    }
  }

  private _generateTimeString(timestamp: number) {
    const activityDate = new Date(timestamp);
    const dayName = Constants.DAYS[activityDate.getDay()];
    const dateString = `${dayName}, ${activityDate.toLocaleString('default', {
      month: 'long',
    })} ${activityDate.getDate()}`;
    // Ensure single digit minutes have a leading 0
    const stringMinutes =
      (activityDate.getMinutes() < 10 ? '0' : '') + activityDate.getMinutes();
    const timeString = `${activityDate.getHours()}:${stringMinutes}`;
    return `${dateString} @ ${timeString}`;
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
